// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__37H3g","footerInner":"style_footerInner__1ZL1V","logo":"style_logo__tIJSM"};